import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { PageLoader, EmptyState } from "@/components/Loading";
import { categoryLabel } from "@/lib/constants";
import { Building2, Users, ArrowRight, ChevronLeft } from "lucide-react";

export default function UnitDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/units/${id}/students`).then((r) => setData(r.data)).catch(() => setData(false)); }, [id]);
  if (data === null) return <PageLoader />;
  if (data === false) return <EmptyState icon={Building2} title="تعذّر تحميل الوحدة" />;

  return (
    <div className="animate-fade-in">
      <button onClick={() => nav("/app/units")} className="mb-4 flex items-center gap-1 text-sm text-slate-500 hover:text-navy"><ArrowRight className="h-4 w-4" /> رجوع للوحدات</button>
      <PageHeader title={data.unit?.name || "الوحدة السكنية"} subtitle={`${data.unit ? categoryLabel[data.unit.gender] : ""} • ${data.students.length} طالب`} />
      {data.students.length === 0 ? <EmptyState icon={Users} title="لا يوجد طلاب في هذه الوحدة" /> : (
        <div className="overflow-hidden rounded-2xl border border-slate-100 bg-card soft-shadow">
          <table className="w-full text-start text-sm">
            <thead className="bg-slate-50 text-slate-500">
              <tr>
                <th className="p-4 text-start font-semibold">#</th>
                <th className="p-4 text-start font-semibold">الطالب</th>
                <th className="p-4 text-start font-semibold">النقاط</th>
                <th className="p-4 text-start font-semibold">المستوى</th>
                <th className="p-4 text-start font-semibold">الحضور</th>
                <th className="p-4 text-start font-semibold">البرامج</th>
                <th className="p-4 text-start font-semibold"></th>
              </tr>
            </thead>
            <tbody>
              {data.students.map((s, i) => (
                <tr key={s.id} data-testid={`unit-student-${s.id}`} onClick={() => nav(`/app/students/${s.id}`)} className="cursor-pointer border-t border-slate-100 hover:bg-slate-50/60">
                  <td className="p-4 text-slate-400">{i + 1}</td>
                  <td className="p-4"><p className="font-semibold text-navy">{s.name}</p><p className="text-xs text-slate-400">{s.university_status}</p></td>
                  <td className="p-4 font-bold text-greenx">{s.points}</td>
                  <td className="p-4"><span className="rounded-full bg-amber-50 px-2 py-0.5 text-xs text-gold-dark">{s.level_title}</span></td>
                  <td className="p-4 text-slate-600">{s.attendance_percent}%</td>
                  <td className="p-4 text-slate-600">{s.programs_count}</td>
                  <td className="p-4 text-slate-300"><ChevronLeft className="h-4 w-4" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
